// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "f9b8d8e4073e5c8984ad" + ".chunk.js";
};